import React from 'react';
import { CTAButton, CHECKOUT_URL, PRICE, PRICE_SHORT, Section } from './Shared';
import { Blossom, Sprig } from './FloralDecor';
export function EmotionalClose() {
  return <Section className="max-w-4xl" data-id="element-33" data-mp="vmcwzic09yi6">
      <div className="relative overflow-hidden rounded-3xl border border-brand-sage/40 bg-brand-sageMist/50 p-6 text-center md:p-12" data-id="element-34" data-mp="vlbb0itgbrlo">
        <Blossom aria-hidden="true" className="pointer-events-none absolute -left-6 -top-6 h-32 w-32 text-brand-rose/25" data-id="element-35" data-mp="ql749kicib8n" />
        <Sprig aria-hidden="true" className="pointer-events-none absolute -bottom-8 -right-4 h-48 w-28 text-brand-greenSoft/25" data-id="element-36" data-mp="hmlep5eghvyd" />
        <div className="relative" data-id="element-37" data-mp="cmpab51uk2ia">
          <h2 className="mb-6 font-display text-3xl font-bold leading-tight text-brand-green md:text-4xl" data-id="element-38" data-mp="cnqxg7w50fgd">
            La próxima sesión puede ser diferente.
          </h2>
          <div className="mx-auto mb-10 max-w-2xl space-y-4 text-base leading-relaxed text-brand-textLight md:text-lg" data-id="element-39" data-mp="270gqyoilfmn8">
            <p data-id="element-40" data-mp="222yiez8hn9fr">Hay dos versiones de vos en este momento.</p>
            <p data-id="element-41" data-mp="3529epw6iv925">
              <strong className="text-brand-green" data-id="element-42" data-mp="351hl2qwhjlei">Una</strong> que cierra esta página y la próxima sesión sigue
              improvisando. Sigue sin saber exactamente qué protocolo usar. Sigue llegando a casa agotada. Sigue
              cobrando lo que cobraba hace dos años.
            </p>
            <p className="font-semibold text-brand-greenMid" data-id="element-43" data-mp="304hca88944jp">
              Y otra que decide que hoy es el día en que su práctica cambia para siempre.
            </p>
            <p className="font-serif text-lg italic text-brand-goldDark md:text-xl" data-id="element-44" data-mp="3srtz8jibqedj">
              La pregunta no es si podés pagarlo.
              <br data-id="element-45" data-mp="3e25tn6340tk0" />
              La pregunta es cuántas sesiones más vas a trabajar sin un sistema que te respalde.
            </p>
          </div>

          <div className="mx-auto max-w-md rounded-2xl border-2 border-brand-gold/60 bg-white p-6 shadow-[0_10px_30px_rgba(14,42,30,.12)]" data-id="element-46" data-mp="3izxoo8z1wvsf">
            <span className="relative -top-9 inline-block rounded-full bg-brand-green px-3 py-1 text-xs font-bold text-brand-goldLight" data-id="element-47" data-mp="fdgxy7l4xx5p">
              ⭐ MÁS ELEGIDO
            </span>
            <h3 className="-mt-4 font-serif text-xl font-bold text-brand-green" data-id="element-48" data-mp="k9ky2jrw31s4">🏆 BOTIQUÍN BACH COMPLETO™</h3>
            <p className="my-2 text-4xl font-bold text-brand-greenMid" data-id="element-49" data-mp="g7pvzd24wkda">{PRICE}</p>
            <p className="text-sm font-semibold text-brand-text" data-id="element-50" data-mp="b9oayml5eaz6">2 Tomos + 5 Bonus + Mapa Rápido de las 38 Flores</p>
            <p className="mb-5 mt-1 text-sm leading-relaxed text-brand-muted" data-id="element-51" data-mp="6al5x25644r7">
              Más de 150 páginas + herramientas visuales de consulta. El sistema integral de protocolos, fórmulas,
              técnicas tópicas, protección del terapeuta y monetización profesional.
            </p>
            <CTAButton href={CHECKOUT_URL} variant="gold" fullWidth className="text-sm md:text-base" data-id="element-52" data-mp="3op3winl5lwdy">
              🏆 → QUIERO MI BOTIQUÍN BACH {PRICE_SHORT}
            </CTAButton>
            <p className="mt-4 text-[11px] text-brand-muted" data-id="element-53" data-mp="3eqeqpt6j82e2">
              🛡️ Garantía 7 días · 📥 Descarga inmediata · 🔒 Pago seguro · 💳 Mercado Pago
            </p>
          </div>
        </div>
      </div>
    </Section>;
}